import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { NavbarHeightProvider } from './utils/contexts/NavbarContext';
import { ParallaxProvider } from 'react-scroll-parallax';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ParallaxProvider>
      <NavbarHeightProvider>
        <App />
      </NavbarHeightProvider>
    </ParallaxProvider>
  </React.StrictMode>
);